import { CategoryOutlined } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'

export const CollectionIcon = (props: any) => {
  const theme = useTheme()
  return (
    <CategoryOutlined
      style={{ fontSize: '1.2rem', color: props.color ? props.color : theme.palette.primary.main }}
    />
  )
}
